export default function LineBreak() {
  return (
    <span aria-hidden="true" style={{ display: "block", height: "0.5em" }} />
  );
}
